module.exports = __webpack_public_path__ + "img/home1_yinliu_logo.cbb8bcf9.png";